module.exports = __webpack_public_path__ + "img/u5634.a4ebcf15.png";